var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "table-search-field" } },
    [
      _c("v-text-field", {
        attrs: {
          "append-icon": "search",
          label: _vm.label,
          "single-line": "",
          "hide-details": ""
        },
        model: {
          value: _vm.model_search,
          callback: function($$v) {
            _vm.model_search = $$v
          },
          expression: "model_search"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }